export default "__VITE_PUBLIC_ASSET__d7e162dd__"